import { getAbilities, sumOfAbilities } from "./abilities";
import { getName } from "./name";
import { getOrigin } from "./origin";
import { getBackground } from "./background";
import { getTrait } from "./trait";
import { getDrive } from "./drive";
import { getLooks } from "./looks";
import { getPastAllegiance } from "./pastAllegiance";
import { getStartingBonus } from "./startingBonus";
import { getStartingKit } from "./startingKit";
import { getPersonalTrinket } from "./personalTrinket";
import { getHitPoints } from "./hitPoints";
import { getDefenseRating } from "./defenseRating";
import { getHolos } from "./holos";
import { getItemSlots } from "./itemSlots";

export const getCharacter = ({ formatMessage }) => {
  const name = getName({ formatMessage });
  const abilities = getAbilities();
  const origin = getOrigin({ formatMessage });
  const background = getBackground({ formatMessage });
  const trait = getTrait({ formatMessage });
  const drive = getDrive({ formatMessage });
  const looks = getLooks({ formatMessage });
  const pastAllegiance = getPastAllegiance({ formatMessage });
  const startingBonus =
    sumOfAbilities(abilities) < 0
      ? getStartingBonus({ formatMessage })
      : undefined;
  const startingKit = getStartingKit({ formatMessage });
  const personalTrinket = getPersonalTrinket({ formatMessage });

  const hitPoints = getHitPoints() + (startingBonus?.hpModifier || 0);
  const defenseRating = getDefenseRating(abilities);
  const holos = getHolos();
  const itemSlots = getItemSlots(abilities);

  return {
    name,
    abilities,
    origin,
    background,
    trait,
    drive,
    looks,
    pastAllegiance,
    startingBonus,
    startingKit,
    personalTrinket,
    hitPoints,
    defenseRating,
    holos,
    itemSlots,
  };
};
